module.exports = __webpack_public_path__ + "main-fonts.eceff26a5f33cc81123f.svg";


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/grapesjs/dist/fonts/main-fonts.svg?v=20
// module id = ../../../../grapesjs/dist/fonts/main-fonts.svg?v=20
// module chunks = 2